// Copyright (c) Ping. All rights reserved.

import { processPushWakePayload } from './pendingPushWake';
import type { PushWakePayload } from './pushWake';

function isPushMessage(data: unknown): data is PushWakePayload & { type: string } {
  if (data === null || typeof data !== 'object') {
    return false;
  }
  const rec = data as Record<string, unknown>;
  return rec.type === 'ping-push';
}

/**
 * Listens for `postMessage` from `public/push-sw.js` and triggers inbox fetch.
 */
export function installPushDeliveryListener(): () => void {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return () => {};
  }

  const onMessage = (event: MessageEvent): void => {
    if (!isPushMessage(event.data)) {
      return;
    }
    void processPushWakePayload(event.data);
  };

  navigator.serviceWorker.addEventListener('message', onMessage);
  return () => {
    navigator.serviceWorker.removeEventListener('message', onMessage);
  };
}
